import { availableOrderActions, type OrderStatus } from './orders.js'
import type { OrderBoardColumnKey } from '../api/orders.js'

export interface KanbanColumnDefinition {
  key: OrderBoardColumnKey
  statuses: string[]
  dropStatus: OrderStatus | null
}

// CREATED is a legacy checkout status: it is shown in the "new" column for
// visibility, but the server transition matrix intentionally allows no actions.
export const KANBAN_COLUMNS: KanbanColumnDefinition[] = [
  { key: 'new', statuses: ['CREATED', 'PENDING_CONFIRMATION'], dropStatus: null },
  { key: 'inProgress', statuses: ['CONFIRMED'], dropStatus: 'CONFIRMED' },
  { key: 'preparing', statuses: ['PREPARING'], dropStatus: 'PREPARING' },
  { key: 'ready', statuses: ['READY'], dropStatus: 'READY' },
  { key: 'completedToday', statuses: ['COMPLETED'], dropStatus: 'COMPLETED' },
]

export function columnDefinition(key: OrderBoardColumnKey): KanbanColumnDefinition {
  return KANBAN_COLUMNS.find(column => column.key === key)!
}

export function dropStatusForColumn(key: OrderBoardColumnKey): OrderStatus | null {
  return columnDefinition(key).dropStatus
}

export function canDropOrderToColumn(fromStatus: string, target: OrderBoardColumnKey): boolean {
  const status = dropStatusForColumn(target)
  if (!status) return false
  return availableOrderActions(fromStatus).includes(status)
}

export function isKanbanColumnKey(value: string): value is OrderBoardColumnKey {
  return KANBAN_COLUMNS.some(column => column.key === value)
}
